import httpRequest from 'utils/httpRequest';
import SETTINGS from '../settings';

export const ORIENTATION = rotation => {
  if (rotation === 90) {
    return 3;
  }
  if (rotation === 180) {
    return 2;
  }
  if (rotation === 270) {
    return 1;
  }
  return 0;
};

export const ROTATION = orientation => {
  if (orientation === 3) {
    return 90;
  }
  if (orientation === 2) {
    return 180;
  }
  if (orientation === 1) {
    return 270;
  }
  return 0;
};

export function getTransformedImageUrl(url, query = [], json = false) {
  const params = [`url=${encodeURIComponent(url)}`];
  if (json) {
    params.push('output=json');
  }

  return `${SETTINGS.IMAGIFER_URL}/${query.join('/')}?${params.join('&')}`;
}

export function getImagePreview(url, params = {}) {
  const config = {
    width: params.highQualityImage ? 2000 : 800,
    orientation: 0,
    ...params,
    highQualityImage: undefined
  };

  const query = [
    `rotate:deg=${ROTATION(config.orientation)}&background=00000000`,
    `resize:width=${config.width}`,
  ];

  return getTransformedImageUrl(url, query);
}

export async function getImageSize(url) {
  try {
    const response = await httpRequest(
      `${SETTINGS.IMAGIFER_URL}/imagesize?url=${encodeURIComponent(url)}`,
      {
        method: 'GET',
      },
    );

    const json = await response.json();

    if (json.width && json.height) {
      return { data: { width: json.width, height: json.height } };
    }

    console.log(`Error getting image size for ${url}: ${response}`);
    return { error: 500 };
  } catch (e) {
    return { error: e.code };
  }
}

export async function isPhotoStillExist(url) {
  try {
    const response = await httpRequest(url, {
      method: 'HEAD',
    });

    if (response.ok) {
      return true;
    }

    return false;
  } catch (e) {
    return false;
  }
}
